import './logger-db-core.js';

export interface IFlushResult {
  ok: boolean;
  sentCount: number;
  retryable?: boolean;
  errorMessage?: string;
}

export interface ILoggerDbCore {
  configure: (options: { maxAgeMs: number; maxLogs: number; maxFailedLogs: number }) => void;
  storeLogs: (logs: unknown[], routeKey: string) => Promise<void>;
  flushLogs: (routeKey: string, endpoint: string) => Promise<void>;
  flushLogsCore: (routeKey: string, endpoint: string) => Promise<IFlushResult>;
}

export function getLoggerDbCore(): ILoggerDbCore {
  const core = (globalThis as { LoggerDbCore?: ILoggerDbCore }).LoggerDbCore;
  if (!core) {
    throw new Error('Logger DB core is not available');
  }

  return core;
}
